var createPatternBuilder = require('./createPatternBuilder');
module.exports = generateCreateSpringForceFunction;
module.exports.generateCreateSpringForceFunctionBody = generateCreateSpringForceFunctionBody;
function generateCreateSpringForceFunction(dimension) {
  var code = generateCreateSpringForceFunctionBody(dimension);
  return new Function('options', 'random', code);
}
function generateCreateSpringForceFunctionBody(dimension) {
  var pattern = createPatternBuilder(dimension);
  var code = "\n  if (!Number.isFinite(options.springCoefficient)) throw new Error('Spring coefficient is not a number');\n  if (!Number.isFinite(options.springLength)) throw new Error('Spring length is not a number');\n\n  return {\n    /**\n     * Updates forces acting on a spring\n     */\n    update: function (spring) {\n      var body1 = spring.from;\n      var body2 = spring.to;\n      var length = spring.length < 0 ? options.springLength : spring.length;\n      ".concat(pattern('var d{var} = body2.pos.{var} - body1.pos.{var};', {
    indent: 6
  }), "\n      var r = Math.sqrt(").concat(pattern('d{var} * d{var}', {
    join: ' + '
  }), ");\n\n      if (r === 0) {\n        ").concat(pattern('d{var} = (random.nextDouble() - 0.5) / 50;', {
    indent: 8
  }), "\n        r = Math.sqrt(").concat(pattern('d{var} * d{var}', {
    join: ' + '
  }), ");\n      }\n\n      var d = r - length;\n      var coefficient = ((spring.coefficient > 0) ? spring.coefficient : options.springCoefficient) * d / r;\n\n      ").concat(pattern('body1.force.{var} += coefficient * d{var}', {
    indent: 6
  }), ";\n      body1.springCount += 1;\n      body1.springLength += r;\n\n      ").concat(pattern('body2.force.{var} -= coefficient * d{var}', {
    indent: 6
  }), ";\n      body2.springCount += 1;\n      body2.springLength += r;\n    }\n  };\n");
  return code;
}